import { ReportDateInterface } from '@/components/_common/ReportSelectMonthFields';
import { Moment } from 'moment';

export interface PurchasesReportFormValues extends ReportDateInterface {
  cfopIds?: number[];
  documentTypeIds?: number[];
  suppliersIds?: number[];
  workOrderComplementIds?: number[];
  dateType: FilterByDateReportPurchase;
  lsSituacao: SituationReportPurchase;
  lsPurchaseItems: ItemsReportPurchase;
  reportType: GroupReportByPurchases;
  purchaseCode?: string;
  invoiceKey?: string;
  synthetic?: boolean;
  documentNumber?: string;
}

export interface PurchaseReportRequest extends PurchasesReportFormValues {
  initialDate: string;
  finalDate: string;
}

export enum FilterByDateReportPurchase {
  launch = 'LAUNCH',
  emission = 'EMISSION',
}

export enum SituationReportPurchase {
  open = 'OPEN',
  authorized = 'AUTHORIZED',
  canceled = 'CANCELED',
}

export enum ItemsReportPurchase {
  parts = 'PART',
  consumables = 'CONSUMABLE',
  tasks = 'TASK',
  freightInvoice = 'DELIVERY_NOTE',
}

export enum GroupReportByPurchases {
  date = 'DATE',
  supplier = 'SUPPLIER',
  workOrders = 'WORK_ORDER',
  cfop = 'CFOP',
  documentType = 'DOCUMENT_TYPE',
  supplierSynthetic = 'SUPPLIER_SYNTHETIC',
}

export interface PurchaseDataSynthetic {
  valueLiquidItem: number;
  totalDeliveryValue: number;
  totalIpi: number;
  totalExpensesValue: number;
  totalIcmsSt: number;
  totalLiquidReturned: number;
}

export interface PurchaseCfop extends PurchaseDataSynthetic {
  cfopId: string;
  codeCfop: string;
  descriptionCfop: string;
}

export interface PurchaseDateSupplierWorkorder {
  barcode: string;
  codeCfop: string;
  codePurchase: string;
  companyCode: string;
  dataGrouping: string;
  defaultPartCode: string;
  deliveryType: string;
  discountPercentComplementItem: number;
  discountValuePurchase: number;
  documentNumber: string;
  freightInvoice: boolean;
  id: number;
  internalCode: string;
  issueDate: Moment;
  licensePlate: string;
  manufacturerCode: string;
  nameBrand: string;
  nameInsurer: string;
  nameItem: string;
  nameModel: string;
  nameSupplier: string;
  numberComplementWorkOrder: string;
  numberWorkOrder: string;
  quantityPurchase: number;
  quantityReturned: number;
  releaseDate: Moment;
  situation: string;
  totalDeliveryValue: number;
  totalDiscount: number;
  totalExpensesValue: number;
  totalIcmsSt: number;
  totalIpi: number;
  typeItem: string;
  unitaryComplementItem: number;
  unitaryValuePurchase: number;
  valueDeliveryItem: number;
  valueExpenseItem: number;
  valueIcmsStItem: number;
  valueIpiItem: number;
  valueLiquidItemPurchase: number;
  valueLiquidReturned: number;
  workOrderItemId: number;
}

export interface PurchaseDocumentType extends PurchaseDataSynthetic {
  documentTypeId: string;
  typeDocument: string;
  descriptionDocument: string;
}

export interface PurchaseSupplierSynthetic extends PurchaseDataSynthetic {
  supplierId: number;
  nameSupplier: string;
}
